export const firebaseConfig = {
  apiKey: "AIzaSyBn2zFosrLWAo7aBQSXxEJkeHCpf5RGN2U",
  authDomain: "emailing-engine.firebaseapp.com",
  databaseURL: "https://emailing-engine.firebaseio.com",
  projectId: "emailing-engine",
  storageBucket: "emailing-engine.appspot.com",
  messagingSenderId: "482728010513",
  appId: "1:482728010513:web:39407969089485ab",
};


// WEBPACK FOOTER //
// ./src/FIREBASE_CONFIG.js